import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from '@department-of-veterans-affairs/platform-user/selectors';
import { submitCh31CaseMilestones } from '../actions/ch31-case-milestones';
import { MILESTONE_COMPLETION_TYPES } from '../constants';

export default function CodeOfConduct() {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  const ch31CaseMilestonesState = useSelector(
    state => state?.ch31CaseMilestones,
  );

  const submitMilestoneCompletion = () => {
    dispatch(
      submitCh31CaseMilestones({
        milestoneCompletionType:
          MILESTONE_COMPLETION_TYPES.STEP_4_CODE_OF_CONDUCT_COMPLETION,
        user,
      }),
    );
  };
  return (
    <>
      <h3>Review code of conduct</h3>
      <p>
        Before we can schedule your initial evaluation counselor meeting, review
        and agree to our code of conduct. You can review our code of conduct on
        this screen. Select “I agree” to complete this step.
      </p>
      <h3>Code of conduct when working with a counselor</h3>
      <p>
        We believe that empowering Veterans, service members, and beneficiaries
        in meeting program goals is best achieved in an environment that’s
        collaborative, respectful, and safe. This means everyone is treated with
        care and respect.
      </p>
      <p>
        Because the safety and well-being of Veterans, service members,
        beneficiaries, and VA staff is our top priority, we expect all to
        refrain from behaviors that are disruptive, disrespectful, or pose a
        threat to others.
      </p>
      <p>We prohibit these behaviors:</p>
      <ul>
        <li>
          Making harassing, offensive, or intimidating statements, including
          threats of violence in phone calls, letters, secure messages, emails,
          or other forms of written, verbal, or electronic communication
        </li>
        <li>Making verbal threats to harm others</li>
        <li>Attempting to intimidate or harass others</li>
        <li>Sexually or physically harassing any individuals</li>
      </ul>
      <p>
        We’ll address any inappropriate or unsafe behavior in accordance with
        applicable policies, procedures, and legal requirements.
      </p>
      <va-button
        loading={ch31CaseMilestonesState?.loading}
        onClick={submitMilestoneCompletion}
        text="I agree"
        label="I agree to the VR&E code of conduct"
      />
    </>
  );
}
